import { useState } from 'react'
import { SettingProfile } from '../../components/SettingProfile/SettingProfile'
import './ProfilePage.scss'
import { FavoritesMovies } from '../../components/FavoritesMovies/FavoritesMovies'
import { useWindowResize } from '../../components/hooks/useWindowResize'
import svg from "../../assets/img/sprite.svg";

export const ProfilePage = () => {

    const [activeComponent, setActiveComponent] = useState('FavoritesMovies')

    const handleButtonClick = (component: string) => {
        setActiveComponent(component); // При клике устанавливаем активный компонент
    };

    const resize = useWindowResize()

    return (
        <div className='container'>
            <h2 className='title-min'>Мой аккаунт</h2>
            <nav className="nav-profile">
                <ul className="nav-profile__list">
                    <li className="nav-profile__item">
                        <button className={activeComponent === 'FavoritesMovies' ? "nav-profile__link active" : "nav-profile__link"} onClick={() => handleButtonClick('FavoritesMovies')}>
                            <svg  width="24" height="24">
                                <use xlinkHref={`${svg}#noLike`}></use>
                            </svg>
                            {resize ? 'Избранное' : 'Избранные фильмы'}
                        </button>
                    </li>
                    <li className="nav-profile__item">
                        <button className={activeComponent === 'SettingProfile' ? "nav-profile__link active" : "nav-profile__link"} onClick={() => handleButtonClick('SettingProfile')}>
                        <svg  width="24" height="24">
                                <use xlinkHref={`${svg}#profileUser`}></use>
                            </svg>
                            {resize ? 'Настройки' : 'Настройка аккаунта'}
                        </button>
                    </li>

                </ul>
            </nav>
            {activeComponent === 'FavoritesMovies' ? <FavoritesMovies /> : activeComponent === 'SettingProfile' ? <SettingProfile /> : null}
        </div>
    )


}



